<template>
  <div class="landing-feature-grid" :class="{ 'landing-feature-grid--reverse': reverse }">
    <div class="landing-fade-up" :style="reverse ? { order: 2 } : null">
      <div class="landing-eyebrow" :style="{ color: eyebrowColor, marginBottom: '14px' }">{{ eyebrow }}</div>
      <h2 class="landing-h2" v-html="title" />
      <p class="landing-lead">{{ lead }}</p>

      <div style="display: flex; flex-direction: column; gap: 16px; margin-top: 30px">
        <div v-for="item in bullets" :key="item.strong" class="landing-f-bullet">
          <span class="landing-f-check" :style="{ background: checkBg }">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" :stroke="checkColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="20,6 9,17 4,12" />
            </svg>
          </span>
          <span style="font-size: 15px; color: #374151; line-height: 1.5">
            <strong>{{ item.strong }}</strong> {{ item.text }}
          </span>
        </div>
      </div>

      <slot name="extra" />

      <router-link
        :to="ctaTo"
        :class="ctaGhost ? 'landing-btn-ghost-dark' : 'landing-btn-red'"
        style="margin-top: 30px; display: inline-flex"
      >
        {{ ctaText }}
      </router-link>
    </div>

    <div class="landing-fade-up" :style="reverse ? { order: 1 } : null">
      <div class="landing-mockframe">
        <div class="landing-mockbar">
          <div class="landing-mockdot" style="background: #ff5f57" />
          <div class="landing-mockdot" style="background: #febc2e" />
          <div class="landing-mockdot" style="background: #28c840" />
        </div>
        <ImageSlot
          :src="screenshot"
          :placeholder="screenshotPlaceholder"
          fit="contain"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImageSlot from '@/components/landing/ImageSlot.vue';

export default {
  name: 'FeatureSection',
  components: { ImageSlot },
  props: {
    eyebrow: { type: String, required: true },
    title: { type: String, required: true },
    lead: { type: String, required: true },
    bullets: { type: Array, required: true },
    ctaText: { type: String, required: true },
    ctaTo: { type: String, required: true },
    ctaGhost: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    screenshot: { type: String, default: '' },
    screenshotPlaceholder: { type: String, default: '' },
    eyebrowColor: { type: String, default: 'var(--red)' },
    checkColor: { type: String, default: '#E8192C' },
    checkBg: { type: String, default: 'var(--rl)' },
  },
};
</script>
